/* global CONFIG */
import moment from 'moment-timezone'
import ft from './featureToggle'
const request = require('browser-request')

export default {
  saveReview (VueApp, id, firstName, lastName, value, message, callback) {
    let url = '/reservations/' + id + '/' + firstName + '/' + lastName + '/review'
    VueApp.$sdk.post(VueApp, url, { value, message }, r => {
      callback(r)
    })
  },
  search (VueApp, id, firstName, lastName, onSuccess, onError) {
    let self = this
    let url = '/reservations/' + id + '/' + encodeURIComponent(firstName) + '/' + encodeURIComponent(lastName)
    VueApp.$sdk.get(VueApp, url, {}, r => {
      if (r.error) {
        onError(r)
        return
      }

      if (!r.pickupTimezone) {
        self.getTimezone(VueApp, r, onSuccess)
      } else {
        onSuccess(self.formatRsvp(VueApp, r))
      }

      if (r.optinShared && r.optinShared.isOptinShared) {
        VueApp.$store.commit('reservation/setOptinData', {
          leg: 'leg1',
          fields: {enabled: true}
        })
      }
    })
  },
  formatRsvp (VueApp, rsvp) {
    let dispatchStatus = rsvp.dispatchStatus
    if (rsvp.status === 'ontheway' || rsvp.status === 'arrived') {
      dispatchStatus = 'ontheway'
    }

    let flightNumber = rsvp.flightNumber || ''
    let flightName = rsvp.airline || ''
    if (rsvp.dropoffAirline) {
      flightNumber = rsvp.dropoffFlightNumber
      flightName = rsvp.dropoffAirline
    }

    if (rsvp.optinShared && rsvp.optinShared.isOptinShared && rsvp.optinShared.current === 'shared') {
      rsvp.breakdown.fare = rsvp.optinShared.exclusive.amount
      rsvp.breakdown.total = rsvp.optinShared.exclusive.amount + rsvp.breakdown.airportFee + rsvp.breakdown.pickupFee + rsvp.breakdown.tip + rsvp.breakdown.travelInsurance - rsvp.breakdown.promo
    }

    if (!rsvp.pickupTimezone) {
      this.getTimezone(VueApp, rsvp)
      return
    }

    let rsvpData = {
      id: rsvp.ID,
      bidID: rsvp.bidID,
      brandID: rsvp.brandID,
      consumer: rsvp.consumer,
      provider: rsvp.provider,
      vehicle: rsvp.vehicle,
      // pickupTime: moment(rsvp.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickupTime: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(rsvp.pickupTimezone).format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickup: rsvp.pickupLocation,
      dropoff: rsvp.dropoffLocation,
      distance: rsvp.distance,
      eta: rsvp.etaInSec,
      guest: rsvp.guest,
      payment: rsvp.breakdown,
      originalPrice: rsvp.originalPrice,
      notes: rsvp.notes,
      passengers: rsvp.passengers,
      luggage: rsvp.luggage,
      airline: flightName,
      airlineCode: rsvp.airlineCode,
      terminal: rsvp.terminal,
      flightNumber: flightNumber,
      pickupType: rsvp.pickupType === '' || rsvp.pickupType === 'N/A' ? null : rsvp.pickupType,
      cardTitle: rsvp.cardTitle,
      cardNumber: rsvp.cardNumber,
      cardID: rsvp.cardID,
      isAsap: rsvp.isAsap,
      serviceLabel: rsvp.serviceLabel,
      serviceCode: rsvp.serviceCode,
      serviceId: rsvp.serviceType.id,
      dispatchStatus: dispatchStatus,
      ada: {
        wheelchair: rsvp.ada.wheelChairLift === 1,
        serviceDog: rsvp.ada.serviceDog === 1
      },
      pickupTimezone: rsvp.pickupTimezone || 'America/Los_Angeles',
      rating: rsvp.rating,
      hasExtraStop: rsvp.hasExtraStop,
      isCharter: rsvp.isCharter,
      gasFee: rsvp.gasFee || 0,
      pkgId: rsvp.packageID,
      isMtech: rsvp.isMTech || false,
      rawPickupDate: rsvp.pickupDate,
      mtechService: rsvp.mtechProductData,
      discountCode: rsvp.corporateProfile && rsvp.corporateProfile.id ? rsvp.corporateProfile.discountCode : '',
      isCorporate: typeof rsvp.corporateProfile === 'object',
      lyft: rsvp.lyft || null
    }
    if (rsvp.serviceType.id > 5) {
      rsvpData.serviceLabel = rsvp.serviceType.name
      rsvpData.serviceCode = 'a' + rsvp.serviceType.id
    }
    if (rsvp.provider.ID === CONFIG.lyft.driverId) rsvpData.isLyft = true
    if (rsvp.lyft) {
      rsvpData.serviceLabel = rsvp.lyft.custom_name
    }
    return rsvpData
  },
  getTimezone (VueApp, rsvp, onSuccess) {
    let self = this
    let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
    url = url.replace('{AT}', encodeURIComponent(rsvp.pickupLocation.lat + ',' + rsvp.pickupLocation.lng))
      .replace('{API_KEY}', CONFIG.hereApi.key)
    request.get({
      url: url,
      json: true
    }, function (err, res, body) {
      if (err || !body.items.length) {
        VueApp.$store.commit('global/setLoaderData', {show: false})
        VueApp.$store.commit('global/setAlertData', {
          show: true,
          message: 'Oops something went wrong. please try again later.'
        })
        console.log('timezone err:', err)
        return
      }
      if (body.items.length) {
        rsvp.pickupTimezone = body.items[0].timeZone.name
      }
      onSuccess(self.formatRsvp(VueApp, rsvp))
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservation-search.js